import { Pipe, PipeTransform } from '@angular/core';
import { GlobalConstants } from '../../core/constants/globals';

@Pipe({
    name: 'userImage'
})
export class UserImagePipe implements PipeTransform {
    transform(userImage: string): string {
        if (userImage !== undefined) {
            var divideImageURLString = userImage.split('/');
            var imageName = divideImageURLString[divideImageURLString.length - 1];

            //if image is empty return default image
            if (userImage === '') {
                return GlobalConstants.DEFAULT_IMAGE;
            }
            //if image url has no path e.g /bea/attachment/stcuserimages/.jpg
            else if (imageName.startsWith('.')) {
                return GlobalConstants.DEFAULT_IMAGE;
            }

            //if image url has image host name e.g https://igateapp.stc.com.sa/
            //return image as is
            else if (userImage.includes(GlobalConstants.HOST_NAME)) {
                return userImage;
            }

            //if image url has image path e.g /bea/attachment/stcuserimages/{{imageName}}.jpg
            //return image  with host name
            else {
                return GlobalConstants.HOST_NAME + '' + userImage;
            }
        }
        //if user image is undefined, return default image
        else if (userImage === undefined) {
            return GlobalConstants.DEFAULT_IMAGE;
        } else {
            return GlobalConstants.DEFAULT_IMAGE;
        }
    }
}
